import { render } from "./Contact-page.vue?vue&type=template&id=23a3dba0"
import script from "./Contact-page.vue?vue&type=script&lang=js"
export * from "./Contact-page.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__